import { createFileRoute } from "@tanstack/react-router";
import { protectedRoute } from "@/lib/protectedRoute";
import { Visit } from "@/pages/Visit";

export const Route = createFileRoute("/visits/$visitPublicId")({
  component: Visit,
  beforeLoad: () => {
    return protectedRoute({ location: window.location });
  },
});
